module.exports = __webpack_public_path__ + "img/010_mars_thb.ca7c6116.jpg";